import { AnyAction } from 'redux';
import { modeOfOnboardingDougnutType } from '../../components/dashboard/doughnutGraph';
import { modeOfOnboardingDashboardType } from '../types/api-types';
import { GET_MODE_OF_ONBOARDING_DASHBOARD_DETAILS_SUCCESS } from '../types/application';
import { LOGOUT_SUCCESS } from '../types/auth';

function modeOfOnboardingDashboardDoughnutReducer(
  state = modeOfOnboardingDougnutType,
  action: AnyAction
): Partial<modeOfOnboardingDashboardType> {
  switch (action.type) {
    case GET_MODE_OF_ONBOARDING_DASHBOARD_DETAILS_SUCCESS: {
      return action.body;
    }
    case LOGOUT_SUCCESS: {
      return modeOfOnboardingDougnutType;
    }

    default:
      return state;
  }
}

export default modeOfOnboardingDashboardDoughnutReducer;
